import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import { NavBar, ContextColorProvider } from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { Header } from './components/Header';
import { Statements } from './components/Statements';
import { BrokerageNotes } from './components/BrokerageNotes';
import { Tabs } from './components/Tabs';

import { PortfolioMontlhyStatementListFilterOption } from '@/modules/wealth/services/portfolio';
import { TabsIndexes } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioStatementsAndBrokerageNotes',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const currentTabIndex = ref<TabsIndexes>(TabsIndexes.Statements);
const portfolioName = ref<string | null>(null);
const isHeaderLoading = ref(true);
const selectedYear = ref<number | string | null>(null);
const yearOptions = ref<PortfolioMontlhyStatementListFilterOption[]>([]);

const portfolioId = computed(() => {
  const { portfolioId } = route.params;

  return portfolioId;
});

const onChangeTab = (tabIndex: TabsIndexes) => {
  currentTabIndex.value = tabIndex;
};

const onChangeYear = (newSelectedYear: number | string) => {
  selectedYear.value = newSelectedYear;
};

const setHeaderInfo = (
  newPortfolioName?: string | null,
  newSelectedYear?: number | string,
  newYearOptions?: PortfolioMontlhyStatementListFilterOption[]
) => {
  if (newPortfolioName) {
    portfolioName.value = newPortfolioName;
  }
  if (newSelectedYear) {
    selectedYear.value = newSelectedYear;
  }
  if (newYearOptions) {
    yearOptions.value = newYearOptions;
  }

  isHeaderLoading.value = false;
};

const handleGoBackClick = () => {
  router.replace({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value }
  });
};

return { __sfc: true,route, router, currentTabIndex, portfolioName, isHeaderLoading, selectedYear, yearOptions, portfolioId, onChangeTab, onChangeYear, setHeaderInfo, handleGoBackClick, NavBar, ContextColorProvider, BackButton, Header, Statements, BrokerageNotes, Tabs, TabsIndexes }
}

})